var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11630",
    transform: "translate(-12853.507 6841.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11627",
    transform: "translate(12854.5 -6840.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,45.7c-0.3,0-0.6-0.1-1-0.2c-1.2-0.5-1.7-1.9-1.1-3.1L20.9,1.7C21.4,0.5,22.8,0,24,0.5c1.2,0.5,1.7,1.9,1.1,3.1 L6.6,44.3C6.2,45.2,5.4,45.7,4.5,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,45.7c-0.9,0-1.7-0.5-2.1-1.4L20.9,3.6c-0.5-1.2,0-2.5,1.1-3.1c1.2-0.5,2.5,0,3.1,1.1l18.5,40.7 c0.5,1.2,0,2.5-1.1,3.1C42.2,45.6,41.8,45.7,41.5,45.7z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12886.8-6813.8h-18.5c-1.3,0-2.3-1-2.3-2.3c0-1.3,1-2.3,2.3-2.3h18.5c1.3,0,2.3,1,2.3,2.3 C12889.1-6814.9,12888-6813.8,12886.8-6813.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/Language.124266ccaa1a9c84e9e5c6fe161a5e83.svg";
export { ForwardRef as ReactComponent };